import { Expose } from "class-transformer";

export interface IConversationDto {
  sessionId: string;
  owner: number;
}

export class ConversationDto implements IConversationDto {
  @Expose()
  sessionId!: string;

  @Expose()
  owner!: number;
}
